export default function authHeader() {
    const user = JSON.parse(localStorage.getItem('user'));

    if (user && user.token) {
      return { 'AUTHORIZATION': user.token };
    } else {
      return {};
    }
  }